import '@vfde-brix/button/dist/styles.css';
import { createActionTileComponent } from '@vfde-brix/action-tile';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createComponents } from '../../utils/initComponents';

createComponents('brix-action-tile', createActionTileComponent, NO_PATTERN_BUSINESS_LOGIC);
